import React, { PropsWithChildren, PureComponent, ReactNode } from 'react';

interface FlowGridProps {
    columns: number;
}

export class FlowGrid extends PureComponent<PropsWithChildren<FlowGridProps>> {
    renderRow = (rowId: number, elements: ReactNode[]) => {
        return (
            <tr key={rowId}>
                {Array.from(Array(this.props.columns).keys()).map(colId => {
                    const cellElement = colId < elements.length ? elements[colId] : null;
                    return <td key={colId}>{cellElement}</td>;
                })}
            </tr>
        );
    };

    render() {
        const children = React.Children.toArray(this.props.children);
        const nbRows = Math.ceil(children.length / this.props.columns);
        return (
            <table className="flow-grid">
                <tbody>
                    {Array.from(Array(nbRows).keys()).map(rowId => {
                        const startIdx = this.props.columns * rowId;
                        const endIdx = Math.min(children.length, startIdx + this.props.columns);
                        return this.renderRow(rowId, children.slice(startIdx, endIdx + 1));
                    })}
                </tbody>
            </table>
        );
    }
}
